import { ViewNodeAuditLogsLink } from 'features/cluster/nodes/_components/ViewNodeAuditLogsLink';

import { NodeDetailsTime } from 'features/cluster/nodes/components/NodeDetailsTime';
import { NodeWithDependencies } from 'features/cluster/nodes/types';
import { Detail } from './Detail';

import { Section } from './Section';
import { Stack } from '@cast/design-system';

type Props = {
  node: NodeWithDependencies;
};

const TITLE = 'Details';

export const DetailsSection = ({ node }: Props) => {
  return (
    <Section title={TITLE} testId="node-details-details-section">
      <Detail
        title="Joined:"
        detail={<NodeDetailsTime date={node.joinedAt} preciseFormat={false} />}
        testId="node-details-joined"
      />
      <Detail
        title="Created:"
        detail={<NodeDetailsTime date={node.createdAt} preciseFormat={false} />}
        testId="node-details-created"
      />
      <Detail
        title="Added by:"
        detail={node.addedBy}
        testId="node-details-added-by"
      />
      <Stack direction="row" justifyContent="flex-end">
        <ViewNodeAuditLogsLink node={node} />
      </Stack>
    </Section>
  );
};

const DetailsSectionSkeleton = () => {
  return (
    <Section title={TITLE}>
      <Detail.Skeleton />
      <Detail.Skeleton />
      <Detail.Skeleton />
      <Detail.Skeleton />
    </Section>
  );
};

DetailsSection.Skeleton = DetailsSectionSkeleton;
